import { Fragment } from 'react';

import { useUnitOfMeasureTranslation } from 'support/helpers/unitOfMeasure/unitOfMeasure';

import { GlobalValue } from '../GlobalValue/GlobalValue';

type UnitsOfMeasureCellProps = {
  units: Array<string>;
};

export const UnitsOfMeasureCell = ({ units }: UnitsOfMeasureCellProps) => {
  if (units.length === 0) {
    return <GlobalValue />;
  }

  return (
    <span className="text-gray-700">
      {units.map((unit, index) => (
        <Fragment key={`${unit}-${index}`}>
          {index > 0 ? ', ' : null}
          <UnitOfMeasureLabel unitOfMeasure={unit} />
        </Fragment>
      ))}
    </span>
  );
};

const UnitOfMeasureLabel = ({ unitOfMeasure }: { unitOfMeasure: string }) => {
  const label = useUnitOfMeasureTranslation({ unitOfMeasure });

  return label;
};
